import { ref } from "vue";
import { adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreate } from "@/api/admin-payments-scheduled-payments/admin-payments-scheduled-payments";
import { adminV1OrganizationsPaymentsTerminalRefundCreate } from "@/api/admin-payments-terminal/admin-payments-terminal";
import { useCurrentOrganization } from "@/composables/useCurrentOrganization";
import { errorMessageFrom } from "../utils/apiErrorMessage";

export function useRefundScheduledPayment() {
  const { currentOrganizationId } = useCurrentOrganization();
  const isLoading = ref(false);
  const errorMessage = ref("");

  const refundScheduledPayment = async (
    subscriberMembershipId: string,
    scheduledPaymentId: string
  ) => {
    if (!currentOrganizationId.value) {
      errorMessage.value = "No organization selected";
      return;
    }

    isLoading.value = true;
    errorMessage.value = "";

    try {
      await adminV1OrganizationsPaymentsSubscriberMembershipsScheduledPaymentsRefundCreate(
        currentOrganizationId.value,
        subscriberMembershipId,
        scheduledPaymentId
      );
    } catch (error: unknown) {
      errorMessage.value =
        (error as Error)?.message || "Failed to refund scheduled payment";
    }

    isLoading.value = false;
  };

  const refundTerminalPayment = async (scheduledPaymentId: string) => {
    if (!currentOrganizationId.value) {
      errorMessage.value = "No organization selected";
      return;
    }

    isLoading.value = true;
    errorMessage.value = "";

    try {
      await adminV1OrganizationsPaymentsTerminalRefundCreate(
        currentOrganizationId.value,
        scheduledPaymentId
      );
    } catch (error: unknown) {
      errorMessage.value = errorMessageFrom(
        error,
        "Failed to refund terminal payment"
      );
    }

    isLoading.value = false;
  };

  return {
    isLoading,
    errorMessage,
    refundScheduledPayment,
    refundTerminalPayment,
  };
}
